import BenefitCard from './BenefitCard';
import React from 'react';
import { Space, Typography } from 'antd';
import styles from './BenefitSection.module.scss';

const { Title } = Typography;

const BenefitSection = ({
  title,
  data,
  showDelete,
  allowView = true,
  allowEdit = true,
  allowSwitch = true,
  allowDelete = true,
  onView,
  onEdit,
  onToggleOpen,
  onToggleShow,
  onDelete,
  extraNode,
}: any) => {
  return (
    <div className={styles.section}>
      <Title
        level={4}
        className={styles.title}>
        {title}
      </Title>
      <Space
        size={16}
        wrap
        className={styles.list}>
        {data.map((item: any) => (
          <BenefitCard
            key={`${item.benefitsName}-${item.basicBenefitsType}`}
            item={item}
            showDelete={showDelete}
            allowView={allowView}
            allowEdit={allowEdit}
            allowSwitch={allowSwitch}
            allowDelete={allowDelete}
            onView={onView}
            onEdit={onEdit}
            onToggleOpen={onToggleOpen}
            onToggleShow={onToggleShow}
            onDelete={onDelete}
          />
        ))}
        {extraNode}
      </Space>
    </div>
  );
};

export default BenefitSection;
